module.exports = __webpack_public_path__ + "static/media/thumb_WFVQ9920_1024a.268ae67d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/thumb_WFVQ9920_1024a.jpg
// module id = 150
// module chunks = 0